export default () => ({
	message: '',
	placeSelected: null,
	places: [],
	placesUser: [],
	loading: false,
	notificationConfigurations: [],
	selectedNotificationConfig: {},
	hasNewPlace: false,
});
